
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"6","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M1.179 5.5h7.643a.833.833 0 00.589-1.423L5.589.256a.833.833 0 00-1.178 0L.589 4.077A.833.833 0 001.18 5.5z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/img/TriangleFilled.svg